<template>
  <div id="app" class="daily-tour-page">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <hatadialog ref="hatadialog"></hatadialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat class="page-card">
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar dark color="info" class="page-toolbar">
              <v-toolbar-title>{{ $t('Daily-Tour-List') }}</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-menu bottom left offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>

                <v-list class="menu-list">
                  <v-list-tile v-if="PB === 'TRY'" @click="getListExcel()">
                    <v-list-tile-title>
                      Excel {{ $t('Download') }}
                    </v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

          <v-container fluid class="page-container">
            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex pb-3 xs12 sm12 md12>
                  <v-card flat class="filter-card">
                    <v-card-text class="pb-0">
                      <v-layout row wrap>
                        <v-flex xs12 sm6 pt-2 md2>
                          <tarihcomp
                            :etiket="$t('Starting-Date')"
                            :detaygizle="false"
                            :rules="dateRules"
                            :defaultvalue="'ok'"
                            :value="KayitTarihiBasla"
                            v-model="KayitTarihiBasla"
                          ></tarihcomp>
                        </v-flex>

                        <v-flex xs12 pt-2 sm6 md2>
                          <tarihcomp
                            :etiket="$t('Finishing-Date')"
                            :detaygizle="false"
                            :rules="dateRules"
                            :defaultvalue="'ok'"
                            :value="KayitTarihiBitis"
                            v-model="KayitTarihiBitis"
                          ></tarihcomp>
                        </v-flex>

                        <v-flex xs12 pt-2 sm6 md3>
                          <genelarama
                            :autofocuss="true"
                            apiname="SaticiAra"
                            :label="$t('Seller-Code')"
                            v-model="Satici"
                          ></genelarama>
                        </v-flex>

                        <v-flex xs12 sm6 md1 pt-2>
                          <div class="summary-toggle-wrap">
                            <v-checkbox
                              v-model="searchOzet"
                              :label="$t('Summary-List')"
                              hide-details
                              class="mt-0 pt-0"
                              color="info"
                            >
                            </v-checkbox>
                          </div>
                        </v-flex>

                        <v-flex xs12 pt-2 md2>
                          <div class="filter-actions">
                            <div v-if="load1">
                              <v-btn color="info" @click="getList()" fab small dark>
                                <v-icon>search</v-icon>
                              </v-btn>
                            </div>

                            <div v-if="progress" class="progress-wrap">
                              <v-progress-circular
                                indeterminate
                                :width="4"
                                color="blue"
                                size="28"
                              ></v-progress-circular>
                            </div>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md12 pb-3>
                  <ReportTable
                    :headers="headers"
                    :items="itemssatis"
                    :loading="progress"
                    :has-searched="hasSearched"
                    :storage-key="'gunlukturlistesi_report_table'"
                    :search-label="$t('Search')"
                    :show-frontend-export="true"
                    :rows-per-page-items="[20, 100]"
                    class="report-table-host"
                  >
                    <template slot="cell" slot-scope="slotProps">
                      <div
                        class="cell-click-area"
                        @click="onCellClick(slotProps.item, slotProps.column)"
                      >
                        <template v-if="slotProps.column.value === 'PNR_No'">
                          <a
                            href="#"
                            class="pnr-link"
                            @click.prevent.stop="pnrGit(slotProps.item.PNR_No)"
                          >
                            {{ slotProps.item.PNR_No }}
                          </a>
                        </template>
                        <template v-else>
                          {{ slotProps.value }}
                        </template>
                      </div>
                    </template>
                  </ReportTable>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>

          <v-snackbar
            :timeout="timeout"
            :top="y === 'top'"
            :bottom="y === 'bottom'"
            :right="x === 'right'"
            :left="x === 'left'"
            :multi-line="mode === 'multi-line'"
            :vertical="mode === 'vertical'"
            v-model="snackbar"
          >
            {{ text1 }}
            <v-btn flat color="pink" @click="snackbar = false">
              {{ $t('Close') }}
            </v-btn>
          </v-snackbar>

          <v-dialog v-model="dialogupdate" scrollable persistent max-width="500px">
            <v-card flat color="grey lighten-4">
              <v-card-title>{{ $t('Update') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 sm6 md12 pa-1>
                    <v-card flat class="white--text">
                      <v-card flat color="grey lighten-5">
                        <v-card-actions>
                          <v-layout row wrap>
                            <v-flex xs11 sm11 md11>
                              <genelarama
                                :autofocuss="true"
                                apiname="SaticiAra"
                                tip="1"
                                :label="$t('Hotel')"
                                v-model="UpdatePrm.OtelKodu"
                              ></genelarama>
                            </v-flex>

                            <v-flex xs1 sm1 md1>
                              <v-layout
                                row
                                wrap
                                fill-height
                                align-end
                                justify-center
                              >
                                <minisaticieklecomp
                                  v-model="UpdatePrm.OtelKodu"
                                  :label="$t('Add-hotel-Seller')"
                                  saticiKod="1"
                                >
                                </minisaticieklecomp>
                              </v-layout>
                            </v-flex>

                            <v-flex xs11 sm11 md11>
                              <genelarama
                                :autofocuss="true"
                                apiname="SaticiAra"
                                tip="2"
                                :label="$t('Transfer-v4')"
                                v-model="UpdatePrm.Arac"
                              ></genelarama>
                            </v-flex>

                            <v-flex xs1 sm1 md1>
                              <v-layout
                                row
                                wrap
                                fill-height
                                align-end
                                justify-center
                              >
                                <minisaticieklecomp
                                  v-model="UpdatePrm.Rehber"
                                  :label="$t('Add-guide-Seller')"
                                  saticiKod="6"
                                >
                                </minisaticieklecomp>
                              </v-layout>
                            </v-flex>

                            <v-flex xs11 sm11 md11>
                              <genelarama
                                :autofocuss="true"
                                apiname="SaticiAra"
                                tip="6"
                                :label="$t('Guide')"
                                v-model="UpdatePrm.Rehber"
                              ></genelarama>
                            </v-flex>

                            <v-flex xs1 sm1 md1>
                              <v-layout
                                row
                                wrap
                                fill-height
                                align-end
                                justify-center
                              >
                                <minisaticieklecomp
                                  v-model="UpdatePrm.Rehber"
                                  :label="$t('Add-guide-Seller')"
                                  saticiKod="6"
                                >
                                </minisaticieklecomp>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-select
                                hide-details
                                :items="turkoduitems"
                                :label="$t('Tour-Code')"
                                item-text="Aciklama"
                                item-value="Kod"
                                v-model="UpdatePrm.Tip"
                              >
                              </v-select>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-text-field
                                v-model="UpdatePrm.Saat"
                                :label="$t('Hour')"
                                type="time"
                                :rules="[v => !!v || $t('Mandatory-section')]"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="updateiptal()">
                  {{ $t('cancel_button') }}
                </v-btn>
                <v-btn color="blue darken-1" flat @click="updatekayit()">
                  {{ $t('Apply') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>

<script>
import auth from "../../../../api/auth";
import tarihcomp from "../../customcomp/tarihim";
import helpers from "@/components/app/customcomp/helpers.js";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import tool from "../tools";
import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
import genelarama from "@/components/app/coper/comp/genelarama.vue";
import minisaticieklecomp from "@/components/app/coper/component/minisaticieklecomp.vue";
import ReportTable from "@/components/app/customcomp/ReportTable.vue";

function beforeMount() {}

function createHeaders(vm) {
  return [
    {
      text: vm.$t("Period-v2") + "1",
      value: "Donem1",
      type: "date",
      align: "left",
      visible: true,
      sortable: true,
      minWidth: "140px"
    },
    {
      text: vm.$t("Hour"),
      value: "SaatStr",
      type: "text",
      align: "left",
      visible: true,
      sortable: true,
      minWidth: "120px"
    },
    {
      text: vm.$t("Pax"),
      value: "Pax",
      type: "text",
      align: "left",
      visible: true,
      sortable: true,
      minWidth: "110px"
    },
    {
      text: vm.$t("PNR_No"),
      value: "PNR_No",
      type: "text",
      align: "left",
      visible: true,
      sortable: true,
      minWidth: "140px"
    },
    {
      text: vm.$t("Tour-Code"),
      value: "TurKodu",
      type: "text",
      align: "left",
      visible: true,
      sortable: true,
      minWidth: "140px"
    },
    {
      text: vm.$t("Meeting-Place"),
      value: "BulusmaYeri",
      type: "text",
      align: "left",
      visible: true,
      sortable: true,
      minWidth: "180px"
    },
    {
      text: vm.$t("Name"),
      value: "Isim",
      type: "text",
      align: "left",
      visible: true,
      sortable: true,
      minWidth: "180px"
    },
    {
      text: vm.$t("Program"),
      value: "Program",
      type: "text",
      align: "left",
      visible: true,
      sortable: true,
      minWidth: "180px"
    },
    {
      text: vm.$t("Transfer-v4"),
      value: "Arac",
      type: "text",
      align: "left",
      visible: true,
      sortable: true,
      minWidth: "160px"
    },
    {
      text: vm.$t("Guide"),
      value: "RehberAd",
      type: "text",
      align: "left",
      visible: true,
      sortable: true,
      minWidth: "160px"
    },
    {
      text: vm.$t("Reservation-Code"),
      value: "RezzKod",
      type: "text",
      align: "left",
      visible: true,
      sortable: true,
      minWidth: "150px"
    },
    {
      text: vm.$t("Seller-Code"),
      value: "SaticiKod",
      type: "text",
      align: "left",
      visible: true,
      sortable: true,
      minWidth: "140px"
    },
    {
      text: vm.$t("Daily-Tour-Code"),
      value: "GunlukTurKodu",
      type: "text",
      align: "left",
      visible: true,
      sortable: true,
      minWidth: "170px"
    },
    {
      text: vm.$t("Tour-type"),
      value: "TurTuru",
      type: "text",
      align: "left",
      visible: true,
      sortable: true,
      minWidth: "150px"
    },
    {
      text: vm.$t("Reservation-Status"),
      value: "RezDurumu",
      type: "text",
      align: "left",
      visible: true,
      sortable: true,
      minWidth: "170px"
    },
    {
      text: vm.$t("Hotel-Code"),
      value: "OtelKodu",
      type: "text",
      align: "left",
      visible: true,
      sortable: true,
      minWidth: "140px"
    },
    {
      text: vm.$t("Hotel-Name"),
      value: "OtelAdi",
      type: "text",
      align: "left",
      visible: true,
      sortable: true,
      minWidth: "190px"
    },
    {
      text: vm.$t("Ref"),
      value: "Ref",
      type: "text",
      align: "center",
      visible: true,
      sortable: true,
      minWidth: "120px"
    },
    {
      text: vm.$t("Process-Ref"),
      value: "IslemRef",
      type: "text",
      align: "center",
      visible: true,
      sortable: true,
      minWidth: "140px"
    }
  ];
}

export default {
  name: "GunlukTurIsimListesi",
  beforeMount,
  components: {
    tarihcomp,
    yetkidialog,
    hatadialog,
    genelarama,
    minisaticieklecomp,
    ReportTable
  },
  filters: {
    dateformat(t) {
      return helpers.dateformat(t);
    },
    moneyformat(m) {
      return helpers.moneyformat(m);
    },
    bakiyekontrol(m) {
      return helpers.bakiyekontrol(m);
    }
  },
  data() {
    return {
      headers: [],
      hasSearched: false,
      searchOzet: false,
      itemssatis: [],
      otelitems: [],
      aracitems: [],
      rehberitems: [],
      turkoduitems: [],
      menu1: false,
      UpdatePrm: {
        Ref: "",
        Saat: null,
        Rehber: null,
        Arac: null,
        OtelKodu: null,
        Tip: null
      },
      PB: "TRY",
      Satici: null,
      tumsirketler: false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0
      },
      KayitTarihiBasla: null,
      KayitTarihiBitis: null,
      SaticiKodu: null,
      valid: true,
      loading: false,
      items: [],
      load: false,
      load1: true,
      search3: "",
      renk1: "info",
      dialogupdate: false,
      searchcari: "",
      progress: false,
      butondurum: true,
      snackbar: false,
      y: "top",
      x: "right",
      mode: "",
      timeout: 6000,
      text1: "",
      doviztipi: [],
      dictionary: {
        custom: {
          tarihsec: {
            required: () => this.$t("Please-select-a-date")
          },
          tarihsec1: {
            required: () => this.$t("Please-select-a-date")
          }
        }
      }
    };
  },
  computed: {
    dateRules() {
      return [(v) => !!v || this.$t("Please-select-a-date")];
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.headers = createHeaders(this);

    this.getOtelItems();
    this.getaracItems();
    this.getrehberItems();

    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    const credentialsRaw = window.localStorage.getItem("credentials");
    if (credentialsRaw) {
      try {
        const credentials = JSON.parse(credentialsRaw);
        if (credentials && credentials.ParaBirimi) {
          this.PB = credentials.ParaBirimi;
        }
      } catch (error) {
        this.PB = "TRY";
      }
    }

    if (this.$validator && this.$validator.localize) {
      this.$validator.localize("en", this.dictionary);
    }

    if (credentialsRaw) {
      try {
        const credentials = JSON.parse(credentialsRaw);
        const params = {
          CompanyCode: credentials.SirketKodu
        };

        this.$http
          .post(auth.API_URL + "api/currency/List", params, {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader()
            }
          })
          .then((response) => {
            this.doviztipi = response.body;
          })
          .catch(() => {
            this.text1 = this.$t("Currency-List-Could-Not-Be-Retrieved");
            this.snackbar = true;
          });
      } catch (error) {
        this.text1 = this.$t("Currency-List-Could-Not-Be-Retrieved");
        this.snackbar = true;
      }
    }
  },
  methods: {
    onCellClick(item, column) {
      if (!item || !column) {
        return;
      }

      if (column.value === "PNR_No") {
        return;
      }

      this.git(item);
    },
    pnrGit(val) {
      const url = "#/coper/rezervasyon/index/id?islem=get&PNR_No=" + val;
      window.open(url, "_target");
    },
    getaracItems() {
      const prm = {
        id: "",
        kod: "",
        aciklama: "",
        tip: 2,
        YurtIcDis: 0
      };

      tool.http_post(this, "SaticiAra", prm)
        .then((response) => {
          this.aracitems = response.body;
        })
        .catch(() => {});
    },
    getrehberItems() {
      const prm = {
        id: "",
        kod: "",
        aciklama: "",
        tip: 6,
        YurtIcDis: 0
      };

      tool.http_post(this, "SaticiAra", prm)
        .then((response) => {
          this.rehberitems = response.body;
        })
        .catch(() => {});
    },
    getOtelItems() {
      const prm = {
        id: "",
        kod: "",
        aciklama: "",
        tip: 1,
        YurtIcDis: 0
      };

      tool.http_post(this, "SaticiAra", prm)
        .then((response) => {
          this.otelitems = response.body;
        })
        .catch(() => {});
    },
    turkodugetir(SaticiKod) {
      const params = {
        SaticiKodu: SaticiKod
      };

      tool.http_post(this, "AcenteTurlar", params)
        .then((response) => {
          this.turkoduitems = response.body.data;
        })
        .catch(() => {
          this.text1 = this.$t("Location-could-not-found-error-occured");
          this.snackbar = true;
        });
    },
    updateiptal() {
      this.dialogupdate = false;
    },
    updatekayit() {
      if (this.UpdatePrm.Tip === "") {
        this.UpdatePrm.Tip = null;
      }
      if (this.UpdatePrm.OtelKodu === "") {
        this.UpdatePrm.OtelKodu = null;
      }
      if (this.UpdatePrm.Arac === "") {
        this.UpdatePrm.Arac = null;
      }
      if (this.UpdatePrm.Rehber === "") {
        this.UpdatePrm.Rehber = null;
      }
      if (this.UpdatePrm.Saat === "") {
        this.UpdatePrm.Saat = null;
      }

      if (this.UpdatePrm.Rehber && this.UpdatePrm.Rehber.kod && this.UpdatePrm.Rehber.kod != null) {
        this.UpdatePrm.Rehber = this.UpdatePrm.Rehber.kod;
      } else {
        this.UpdatePrm.Rehber = "";
      }

      if (this.UpdatePrm.OtelKodu && this.UpdatePrm.OtelKodu.kod && this.UpdatePrm.OtelKodu.kod != null) {
        this.UpdatePrm.OtelKodu = this.UpdatePrm.OtelKodu.kod;
      } else {
        this.UpdatePrm.OtelKodu = "";
      }

      if (this.UpdatePrm.Arac && this.UpdatePrm.Arac.kod && this.UpdatePrm.Arac.kod != null) {
        this.UpdatePrm.Arac = this.UpdatePrm.Arac.kod;
      } else {
        this.UpdatePrm.Arac = "";
      }

      tool.http_post(this, "GunlukTurIsimListesiUpdate", this.UpdatePrm)
        .then(() => {
          this.dialogupdate = false;
          this.getList();
        })
        .catch(() => {
          this.text1 = this.$t("Location-could-not-found-error-occured");
          this.snackbar = true;
        });
    },
    HataYonetimi(response, request, baslik) {
      if (response && response.status === 500) {
        this.$refs.hatadialog.open(response, request, baslik);
      } else {
        this.text1 = "Service Unavailable - " + baslik;
        this.snackbar = true;
      }
    },
    git(val) {
      let rehberprm = null;
      if (val.Rehber) {
        rehberprm = {
          kod: val.Rehber,
          id: "0",
          isim: val.RehberAd,
          isimAra: "",
          YurtIci_YurtDisi: "",
          CariKod: "",
          KDV: 0
        };
      }

      let otelprm = null;
      if (val.OtelKodu) {
        otelprm = {
          kod: val.OtelKodu,
          id: "0",
          isim: val.OtelAdi,
          isimAra: "",
          YurtIci_YurtDisi: "",
          CariKod: "",
          KDV: 0
        };
      }

      let transferprm = null;
      if (val.Arac) {
        transferprm = {
          kod: val.Arac,
          id: "0",
          isim: val.AracAd,
          isimAra: "",
          YurtIci_YurtDisi: "",
          CariKod: "",
          KDV: 0
        };
      }

      this.UpdatePrm.Ref = val.Ref;
      this.UpdatePrm.Saat = val.SaatStr;
      this.UpdatePrm.Tip = val.GunlukTurKodu;
      this.UpdatePrm.OtelKodu = otelprm;
      this.UpdatePrm.Arac = transferprm;
      this.UpdatePrm.Rehber = rehberprm;

      this.turkodugetir(val.SaticiKod);
      this.dialogupdate = true;
    },
    validateDateRange() {
      if (!this.$refs.formgunluksatis.validate()) {
        return false;
      }

      const bastarih = new Date(this.KayitTarihiBasla);
      const bittarih = new Date(this.KayitTarihiBitis);

      if (bastarih <= bittarih) {
        return true;
      }

      this.text1 = this.$t("start-date-cannot-greater-than-end-date");
      this.snackbar = true;
      return false;
    },
    createListParams() {
      let saticiprm = null;

      if (this.Satici != null) {
        saticiprm = this.Satici.kod;
      }

      return {
        Tarih1: new Date(this.KayitTarihiBasla),
        Tarih2: new Date(this.KayitTarihiBitis),
        SaticiKod: saticiprm,
        Ozet: this.searchOzet
      };
    },
    getList() {
      if (!this.validateDateRange()) {
        return;
      }

      this.hasSearched = true;
      this.progress = true;
      this.load1 = false;

      const RaporParam = this.createListParams();

      tool.http_post(this, "GunlukTurIsimListesi", RaporParam)
        .then((response) => {
          if (response.body.Status === true) {
            this.itemssatis = response.body.data || [];
          } else {
            this.itemssatis = [];
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        })
        .catch((response) => {
          this.HataYonetimi(response, RaporParam, this.$t("Daily-Tour-List-Could-Not-Be-Retrieved"));
        })
        .then(() => {
          this.progress = false;
          this.load1 = true;
        });
    },
    getListExcel() {
      if (!this.validateDateRange()) {
        return;
      }

      this.progress = true;
      this.load1 = false;

      const RaporParam = this.createListParams();

      tool.api_post_FileDownload(this, "Coper/ExcelGunlukTurIsimListesi", RaporParam)
        .then((response) => {
          tool.CreateDownloadLink(response, "GunlukTurIsimListesi.xlsx");
        })
        .catch(() => {
          this.text1 = "Service Unavailable - Excel";
          this.snackbar = true;
        })
        .then(() => {
          this.progress = false;
          this.load1 = true;
        });
    }
  }
};
</script>

<style scoped>
.daily-tour-page {
  min-height: 100vh;
  background: #f1f3f5;
}

.page-card {
  min-height: 100vh;
}

.page-toolbar {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
}

.page-container {
  padding-top: 22px;
}

.filter-card {
  background: #ffffff;
  border-radius: 4px;
}

.filter-actions {
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 10px;
}

.progress-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.summary-toggle-wrap {
  min-height: 48px;
  display: flex;
  align-items: center;
}

.report-table-host {
  width: 100%;
}

.cell-click-area {
  display: block;
  width: 100%;
  min-height: 24px;
  cursor: pointer;
}

.pnr-link {
  color: #1976d2;
  text-decoration: underline;
  cursor: pointer;
}

.menu-list {
  min-width: 340px;
}

@media (max-width: 960px) {
  .filter-actions {
    justify-content: flex-start;
  }
}
</style>